import Api from 'api/base/axios.config';
import {
  CreateUserPayload,
  GetUserParams,
  UpdateUserPayload,
  UserMutationResponse,
  UserListQueryParams,
} from 'api/users/types';
import { replaceEmptyDataWithNull } from 'utils';

const BASE_URL = '/data-tool-users';

// api call to get user list
export const getUserList = async (params: UserListQueryParams = {}) => {
  const userList = await Api.get(BASE_URL, { params });
  return userList.data;
};

// api call to add users
export const postUser = async (params: CreateUserPayload) => {
  const formattedData = replaceEmptyDataWithNull(params);
  const userDetails = await Api.post<UserMutationResponse>(`${BASE_URL}/`, formattedData);

  return userDetails.data;
};

// api call to delete users
export const deleteUser = async (params: GetUserParams) => {
  const userList = await Api.delete(`${BASE_URL}/`, { data: params });

  return userList.data;
};

// api call to update users
export const updateUser = async (params: UpdateUserPayload) => {
  const formattedData = replaceEmptyDataWithNull(params);
  const updateUser = await Api.put<UserMutationResponse>(`${BASE_URL}/`, formattedData);

  return updateUser.data;
};
